module.exports = __webpack_public_path__ + "static/img/logo-project.0db477d9.png";